import { useQuery, useMutation } from '@apollo/client';
import { GET_OATT_VENDORS, UPDATE_OATT_VENDOR } from '@graphql/oattVendorInfo.gql';

export function useOattVendorList() {
  const { data, loading, error, refetch } = useQuery(GET_OATT_VENDORS);

  const [updateVendorMutation, { loading: updatingVendor }] = useMutation(UPDATE_OATT_VENDOR);

  const handleUpdateVendor = async (input: {
    oatt_vendor_info_id: number;
    company_name?: string;
    contact_name?: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    account_number?: string;
    apply_hst?: string;
    vendor_comment?: string;
  }) => {
    try {
      const result = await updateVendorMutation({ variables: { input } });
      const payload = result.data?.updateOattVendor;
      return { success: payload?.success ?? false, error: payload?.message };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Update failed' };
    }
  };

  return {
    data: data?.oattVendors ?? [],
    loading,
    error,
    refetch,
    handleUpdateVendor,
    updatingVendor,
  };
}
